
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voterguides/2024",
      function () {
        return require("private-next-pages/voterguides/2024.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voterguides/2024"])
      });
    }
  